module.exports = __webpack_public_path__ + "img/logo.e5e1535e.svg";